var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 19H2.77778C2.30628 19 1.8541 18.8104 1.5207 18.4728C1.1873 18.1352 1 17.6774 1 17.2V7.3L9 1L17 7.3V17.2C17 17.6774 16.8127 18.1352 16.4793 18.4728C16.1459 18.8104 15.6937 19 15.2222 19H12M6 19V10H12V19M6 19H12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallHouse);
export default __webpack_public_path__ + "static/media/small-house.f3a130b5d5886a1bf55f2caa4d26b697.svg";
export { ForwardRef as ReactComponent };